// extracted by mini-css-extract-plugin
export var sliderRange = "_qo-2";
export var sliderRoot = "_qo-0";
export var sliderThumb = "_qo-3";
export var sliderTrack = "_qo-1";